export { isShadowing, isContextPrimary, compareShadow } from './compareShadow';
export type {
  PromotionContextTreatment,
  ShadowComparisonResult,
} from './compareShadow';
export { logShadowMismatch } from './logShadowMismatch';
export type { LogFn } from './logShadowMismatch';
export { PromotionCapture } from './PromotionCapture';
export { useShadowComparison } from './useShadowComparison';
